import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Beacon: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <g clip-path='url(#clip0_10464_208597)'>
        <path
          d='M12.1539 14.3432C13.131 14.3432 13.9232 13.5511 13.9232 12.574C13.9232 11.5968 13.131 10.8047 12.1539 10.8047C11.1768 10.8047 10.3846 11.5968 10.3846 12.574C10.3846 13.5511 11.1768 14.3432 12.1539 14.3432Z'
          stroke='currentColor'
          stroke-width='1.32695'
          stroke-linejoin='round'
        />
        <path
          d='M12.1539 20.5366C7.75681 20.5366 4.19225 16.9721 4.19225 12.575C4.19225 8.17785 7.75681 4.61328 12.1539 4.61328'
          stroke='currentColor'
          stroke-width='1.5'
          stroke-linejoin='round'
          stroke-dasharray='2.65 1.77'
        />
        <path
          d='M12.1539 20.5366C16.551 20.5366 20.1156 16.9721 20.1156 12.575C20.1156 8.17785 16.551 4.61328 12.1539 4.61328'
          stroke='currentColor'
          stroke-width='1.5'
          stroke-linejoin='round'
          stroke-dasharray='2.65 1.77'
        />
        <circle cx='12.1539' cy='8.15026' r='0.884631' fill='currentColor' />
        <circle
          cx='15.9844'
          cy='14.7867'
          r='0.884631'
          transform='rotate(120 15.9844 14.7867)'
          fill='currentColor'
        />
        <circle
          cx='0.884631'
          cy='0.884631'
          r='0.884631'
          transform='matrix(0.5 0.866025 0.866025 -0.5 7.11499 14.4629)'
          fill='currentColor'
        />
        <circle
          cx='8.32342'
          cy='10.3617'
          r='0.884631'
          transform='rotate(-60 8.32342 10.3617)'
          fill='currentColor'
        />
        <circle
          cx='15.9844'
          cy='10.3647'
          r='0.884631'
          transform='rotate(60 15.9844 10.3647)'
          fill='currentColor'
        />
        <circle
          cx='0.884631'
          cy='0.884631'
          r='0.884631'
          transform='matrix(1 -8.85319e-08 -8.85319e-08 -1 11.2693 17.8828)'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_10464_208597'>
          <rect
            width='17.6926'
            height='17.6926'
            fill='currentColor'
            transform='translate(3.30762 3.72852)'
          />
        </clipPath>
      </defs>
    </svg>
  </i>
);

Beacon.displayName = 'Beacon';
export default Beacon;
